// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"wl_a bhs_b bhs_ux"};